export function AuditPage() {
  return (
    <div className="page-stack">
      <section className="page-hero page-hero--compact">
        <div>
          <p className="page-hero__eyebrow">Audit</p>
          <h1>Event trail</h1>
          <p>Reserved for audit logging, access reviews, and operational telemetry.</p>
        </div>
      </section>
      <article className="surface-card surface-card--soft">
        <p>No audit integrations are wired yet. Add API-backed event queries here.</p>
      </article>
    </div>
  );
}
